import React from "react";
import { MapContainer, TileLayer, Marker, Polyline, Tooltip } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./WorldMap.css";
import designIcon from "../assets/d-icon.png";
import plantIcon from "../assets/mp-icon.png";
import warehouseIcon from "../assets/w-icon.png";

const iconMap = {
  design: designIcon,
  plant: plantIcon,
  warehouse: warehouseIcon,
};

const createPulsingIcon = (type = "warehouse", size = 32) => {
  const imageUrl = iconMap[type];

  return L.divIcon({
    className: "pulse-divicon",
    html: `
      <div
        class="pulse-marker pulse-${type}"
        style="
          width: ${size}px;
          height: ${size}px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          background: transparent;
          border: none;
        "
      >
        ${
          imageUrl
            ? `<img
                src="${imageUrl}"
                alt="${type}"
                style="
                  width: ${size}px;
                  height: ${size}px;
                  display: block;
                  object-fit: contain;
                  position: relative;
                  z-index: 2;
                "
              />`
            : ""
        }
      </div>
    `,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });
};

const locations = [
  {
    name: "Manufacturing Plant – Thervoy Kandigai, Chennai",
    coords: [13.2172, 79.9542],
    type: "plant",
  },
  {
    name: "Manufacturing Plant – Oragadam, Chennai",
    coords: [12.7909, 79.988],
    type: "plant",
  },
  {
    name: "Manufacturing Plant – Ridgeville, South Carolina, USA",
    coords: [33.4551, -80.3492],
    type: "plant",
  },
  {
    name: "Design Centre – Neckarsulm, Germany",
    coords: [49.1911, 9.2264],
    type: "design",
  },
  {
    name: "Warehouse – US – New York",
    coords: [40.7128, -74.006],
    type: "warehouse",
  },
  {
    name: "Warehouse – US – San Francisco",
    coords: [37.7749, -122.4194],
    type: "warehouse",
  },
  {
    name: "Warehouse – SE – Stockholm",
    coords: [59.3293, 18.0686],
    type: "warehouse",
  },
  {
    name: "Warehouse – DE – Berlin",
    coords: [52.52, 13.405],
    type: "warehouse",
  },
  {
    name: "Warehouse – UK – London",
    coords: [51.5074, -0.1278],
    type: "warehouse",
  },
  {
    name: "Warehouse – India – New Delhi",
    coords: [28.6448, 77.216721],
    type: "warehouse",
  },
  {
    name: "Warehouse – India – Mumbai",
    coords: [19.07609, 72.877426],
    type: "warehouse",
  },
  {
    name: "Warehouse – India – Bengaluru",
    coords: [12.972442, 77.580643],
    type: "warehouse",
  },
  {
    name: "Warehouse – India – Chennai",
    coords: [13.067439, 80.237617],
    type: "warehouse",
  },
  {
    name: "Warehouse – India – Kolkata",
    coords: [22.572645, 88.363892],
    type: "warehouse",
  },
  {
    name: "Warehouse – India – Hyderabad",
    coords: [17.38714, 78.491684],
    type: "warehouse",
  },
];

export default function MapWithAnimatedMarkers() {
  const center = [20, 10];
  const route = locations.map((location) => location.coords);

  return (
    <MapContainer
      center={center}
      zoom={2}
      attributionControl={false}
      style={{
        height: "100%",
        width: "100%",
        position: "relative",
        margin: "0",
      }}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

      {locations.map((loc, index) => (
        <Marker
          key={index}
          position={loc.coords}
          icon={createPulsingIcon(loc.type, 32)}
        >
          <Tooltip
            direction="top"
            offset={[0, -18]}
            opacity={1}
            permanent={false}
          >
            {loc.name}
          </Tooltip>
        </Marker>
      ))}

      <Polyline positions={route} dashArray="6,8" />
    </MapContainer>
  );
}